import { ReactNode } from "react";

export interface TableColumn<T> {
  filterable: boolean;
  header: ReactNode;
  id: string;
  sortable: boolean;
  valueGetter?: (row: T, id: string, index: number, data: T[]) => ReactNode;
  width?: number | string;
}

export enum ColumnTypes {
  APP = "name",
  CURRENT = "currentTask",
  LAST = "lastDeployed",
  LATEST = "latestTask",
  SYNC = "sync",
  VERSION = "version",
  DESIRED = "desiredCount",
  PENDING = "pendingCount",
  RUNNING = "runningCount",
}

export type RowTypes = {
  name: string;
  currentTask: number;
  lastDeployed: string;
  latestTask: number;
  sync: string;
  version: string;
  desiredCount: number;
  pendingCount: number;
  runningCount: number;
};

export type ChangeLog = {
  resourceId: string;
  service: string;
  action: string;
  author: string;
  eventDate: string;
  resourceType: string;
  resourceSubType: string;
  notes: string;
};

export enum SortOrders {
  ASC = "asc",
  DESC = "desc",
  NONE = "none",
}

export type Filters = Record<ColumnTypes, string | undefined>;
